import { useEffect, useRef } from "react";

import "../App.scss";
import "./GameScreen.scss";

function GameScreen(props) {
  const slideAnimation =
    (props.currentQuest?.answer[props.questProgress.selectedAnswer]?.score >
      0 &&
      "dialog__score_slide-in") ||
    (props.currentQuest?.answer[props.questProgress.selectedAnswer]?.score <
      0 &&
      "dialog__score_slide-out");

  const totalScore = useRef();

  useEffect(() => {
    setTimeout(() => {
      totalScore.current = props.questProgress.score;
    }, 500);
  }, [props.questProgress.score]);

  const robotAnswer =
    props.currentQuest.id === "20" ||
    props.currentQuest.id === "14" ||
    props.currentQuest.id === "11" ||
    props.currentQuest.id === "4"
      ? props.currentQuest.answer[props.questProgress.selectedAnswer].robot_line
      : props.currentQuest.robot_line;

  const robotQuestion = props.currentQuest.question;

  const robotLinePlate = (
    <>
      <img
        className={`dialog__robot_line_plate ${
          props.currentQuest.robot_pos === "left"
            ? "dialog__robot_line_plate-top-right"
            : "dialog__robot_line_plate-top-left"
        }
        }`}
        src="../assets/robotLinePlate1.png"
        alt="Robot Line Element 1"
      />
      <div
        className={`dialog__robot_line_background ${
          props.currentQuest.robot_pos === "left"
            ? "dialog__robot_line_background-right"
            : "dialog__robot_line_background-left"
        }`}
      >
        {props.currentQuest.robot_pos === "left" && (
          <img
            // className="dialog__robot_line_background dialog__robot_line_background-right"
            src="../assets/plates/bigPlateRight.png"
            alt="Robot Line Plate"
          />
        )}
        {props.currentQuest.robot_pos === "right" && (
          <img
            // className="dialog__robot_line_background dialog__robot_line_background-left"
            src={`../assets/plates/bigPlateLeft.png`}
            alt="Robot Line Plate"
          />
        )}
        <RobotText
          className={
            props.currentQuest.robot_pos === "left"
              ? "dialog__robot_line_text dialog__robot_line_text-right"
              : `dialog__robot_line_text dialog__robot_line_text-left ${
                  props.questProgress.level + 1 === 14 &&
                  props.questProgress.selectedAnswer === 1 &&
                  "dialog__robot_line_text-14"
                }`
          }
          id={`answer-${props.currentQuest.id}`}
        >
          {props.robotAnswerStatus ? robotAnswer : robotQuestion}
        </RobotText>
      </div>
      <img
        className={`dialog__robot_line_plate ${
          props.currentQuest.robot_pos === "left"
            ? "dialog__robot_line_plate-bottom-right"
            : "dialog__robot_line_plate-bottom-left"
        } ${props.robotAnswerStatus && "dialog__robot_line_plate-bottom-blur"}`}
        src="../assets/robotLinePlate2.png"
        alt="Robot Line Element 2"
      />
    </>
  );

  const robotImage = (
    <img
      onClick={props.robotAnswerStatus ? props.onRobotAnswerSkip : null}
      className={`dialog__robot_image ${
        props?.currentQuest?.robot_pos === "left"
          ? "dialog__robot_image-left"
          : "dialog__robot_image-right"
      }`}
      src={`/assets/robot/${
        (props.questProgress.level === 3 &&
        props.slideScoreStatus &&
        props.questProgress.selectedAnswer === 1)
          ? "sadLeft.png"
          : props.robotAnswerStatus
          ? props.currentQuest.answer[props.questProgress.selectedAnswer]
              .expression
          : props.currentQuest.robot_pos === "left"
          ? "defaultLeft.png"
          : "defaultRight.png"
      }`}
      alt="robot"
    />
  );

  return (
    <>
      {props.robotAnswerStatus && (
        <div
          onClick={props.onRobotAnswerSkip}
          className={"dialog__blur_screen"}
        />
      )}
      <div>
        <div>
          <div className={"dialog_image_container"}>
            <img
              className="dialog__image_border"
              src={`../assets/imageBorder.png`}
              alt="Border"
            />
            <img
              key={props.questProgress.level + "fadein"}
              className={`dialog__image ${"dialog__image_fade_in"}`}
              src={`../assets/cases/${props.currentQuest.image}`}
              alt="Level Illustration"
            />
            {props.previousQuest && (
              <img
                key={props.questProgress.level + "fadeout"}
                className={`dialog__image ${"dialog__image_fade_out"}`}
                src={`../assets/cases/${props.previousQuest.image}`}
                alt="Level Illustration"
              />
            )}
          </div>
          {props.slideScoreStatus &&
            props.currentQuest.answer[props.questProgress.selectedAnswer]
              .score !== 0 && (
              <div className={`dialog__score ${slideAnimation}`}>
                {props.currentQuest.answer[props.questProgress.selectedAnswer]
                  .score + "к"}
              </div>
            )}
          {
            <div className="dialog__score dialog__score_total">
              {props.questProgress.score + "к"}
            </div>
          }
        </div>
        <div className="dialog__description">
          <img
            className="dialog__description_top_line"
            src="../assets/descriptionTopLine.png"
            alt="Description Top Line"
          ></img>
          <img
            className="dialog__description_bar_left"
            src="../assets/descriptionBarLeft.png"
            alt="Description Bar Left"
          ></img>
          <div className="dialog__description_text">
            {props.currentQuest.description}
          </div>
        </div>
      </div>
      <div className="dialog">{robotLinePlate}</div>
      {!props.endingScreen && robotImage}
      <div
        className={`dialog__button ${
          props.robotAnswerStatus && "dialog__button_blur"
        }`}
      >
        <div className="dialog__button_container">
          <button
            className="dialog__buttonA"
            disabled={props.slideScoreStatus}
            onClick={props.onClickA}
          ></button>
          <div
            className={`dialog__button_text ${
              props.questProgress.level === 6 && "dialog__button_text_large"
            }`}
          >
            {props.currentQuest.answer[0].text}
          </div>
        </div>
        <div className="dialog__button_container">
          <button
            className="dialog__buttonB"
            disabled={props.slideScoreStatus}
            onClick={props.onClickB}
          ></button>
          <div className="dialog__button_text">
            {props.currentQuest.answer[1].text}
          </div>
        </div>
      </div>
    </>
  );
}

const RobotText = ({ className, id, children }) => (
  <div className={className} key={id}>
    {children}
  </div>
);

export default GameScreen;
